import { cn } from "@/lib/helpers/cn";

import { buildPageSlots } from "./helpers/build-number-tiles";
import { EllipsisTile } from "./components/EllipsisTile";
import { NumberTile } from "./components/NumberTile";
import { PageControl } from "./components/PageControl";
import { PaginationSkeleton } from "./components/PaginationSkeleton";

type PaginationProps = {
  className?: string;
  currentPage: number;
  isLoading?: boolean;
  maxNavigablePage?: number;
  onPageChange: (page: number) => void;
  totalPages: number;
};

export function Pagination({
  className,
  currentPage,
  isLoading,
  maxNavigablePage,
  onPageChange,
  totalPages,
}: PaginationProps) {
  const slots = buildPageSlots(currentPage, totalPages);

  if (isLoading) return <PaginationSkeleton className={className} />;

  return (
    <nav aria-label="Pagination" className={cn("tw:flex tw:items-center tw:gap-2", className)}>
      <PageControl
        direction="previous"
        isDisabled={currentPage <= 1}
        onPress={() => onPageChange(currentPage - 1)}
      />

      {slots.map((slot, i) =>
        slot === "..." ? (
          <EllipsisTile key={`ellipsis-${i}`} />
        ) : (
          <NumberTile
            isDisabled={maxNavigablePage !== undefined && slot > maxNavigablePage}
            isSelected={slot === currentPage}
            key={slot}
            onPress={() => onPageChange(slot)}
            page={slot}
          />
        ),
      )}

      <PageControl
        direction="next"
        isDisabled={
          currentPage >= totalPages ||
          (maxNavigablePage !== undefined && currentPage >= maxNavigablePage)
        }
        onPress={() => onPageChange(currentPage + 1)}
      />
    </nav>
  );
}
